import { IKeyValPair } from 'app/interfaces/IKeyValPair';
import { ILibraryVal } from 'app/interfaces/ILibraryVal';
import { IAttribute } from '../base/annotation';
import { Named } from 'app/model/base/named';
import { isLogicAppExpression } from 'app/shared/utils/expression.util';

export function databricksLibraryToResource(libraries: Array<IKeyValPair<ILibraryVal>> | undefined): Array<{ [propertyName: string]: {}; }> | undefined {
    let result: Array<{ [propertyName: string]: {}; }>;
    if (libraries && libraries.length > 0) {
        result = [];
        libraries.forEach((item) => {
            const library: { [propertyName: string]: {}; } = {};
            library[item.key] = item.val.value;
            result.push(library);
        });
    }
    return result;
}

export function databricksLibraryToModel(libraries: Array<{ [propertyName: string]: {}; }> | undefined): Array<IKeyValPair<ILibraryVal>> {
    const result: Array<IKeyValPair<ILibraryVal>> = [];
    if (libraries) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        libraries.forEach((library: any) => {
            if (Object.keys(library).length > 0) {
                const key = Object.keys(library)[0];
                result.push({
                    key,
                    val: {
                        value: library[key]
                    }
                });
            }
        });
    }
    return result;
}

export function databricksLibraryWithExpressionToResource(libraries: Array<IKeyValPair<ILibraryVal>> | undefined,
    templateValue: string | undefined): Array<{ [propertyName: string]: {}; }> | undefined | { [propertyName: string]: string; } {
    if (templateValue !== undefined) {
        return {
            value: templateValue,
            type: 'Expression'
        };
    } else {
        return databricksLibraryToResource(libraries);
    }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function databricksLibraryWithExpressionToModel(libraries: any, attr: IAttribute, activity: Named, callback: () => void): void {
    if (libraries['type'] === 'Expression') {
        attr.setTemplateValue(activity, libraries.value);
    } else if (libraries !== undefined) {
        if (typeof libraries === 'string' && isLogicAppExpression(libraries)) {
            attr.setTemplateValue(activity, libraries);
        } else {
            callback();
        }
    }
}
